import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import ActivityIsland from "./ActivityIsland";

//CUSTOM COMPONENT
import ButtonSKA from "../../../aGlobalDesign/Buttons/ButtonSKA";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import SelectResourceDialog from "../../../components/Dialog/SelectResourceDialog";
import AppBar from "../../../aGlobalDesign/Modal/AppBar";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import appSettings from "../../../AppSettings";
import IconComponent from "../../../aGlobalDesign/Icons/IconComponent";
import Loader from "../../../aGlobalDesign/Loader/Loader";
import Area from "../../../aGlobalDesign/Area/Area";
import Status from "../../../aGlobalDesign/Status/Status";
import CallLinkCard from "../../../aGlobalDesign/CallLink/CallLinkCard";
import TextArea from "../../../aGlobalDesign/Inputs/TextArea";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import BadgeAlert from "../../../aGlobalDesign/Badges/BadgeAlert";
import Toggle from "../../../aGlobalDesign/Inputs/Toggle";

class CallPanel extends React.Component {

    constructor() {
        super();
        this.remoteParticipantsRef = {};
        this.state = {
            searchField: "",
            isOnPC: false,
            loadingFile: false,
            currentDate: new Date(),
            currentDateTimer: null,
            selectedDisplayGroup: null,
            mediaStream: null,
            currentRoom: null,
            webRTConnection: null,
            shareScreenConfiguration: appSettings.ShareScreenConfigurationTurn,
            remoteParticipants: {},
            tempResource: null,
            selectResourceDialog: null,
            shareResourceListSelected: null,
            changedResource: false,
            callcategory: null,
            isSendRequestForConsent: false,
            isDisplayRefusedConsent: false,
            formatedDateRequestConsent: "",
            formatedResponseForConsent: "",
            consent: {
                subject: "",
                clientName: "",
                dateRequestConsent: "",
                dateResponseConsent: "",
                isAccepted: false
            },
            isOpenModalCallCategories: false,
            selectedCallCategorie: null,
            selectedAttachment: null,
            totalAttachments: 0,
            currentSession: null,
            srcSharescreenClient: false,
            isDisplaySharescreenClient: false,
            isRecording: false,
            counterRecorder: 0,
            counterScreenshot: 0,
            showPairingCodeDialog: false,
            showErrorMessagePairingCode: false,
            showErrorMessagePairingCodeAlreadyUsed: false,
            codePairingRemoteControl: "",
            displayButtonStopRemoteControl: false,
            isRemoteControlStarted: false,
            showMessageRemoteControlCrashed: false,
            isFocusSharescreen: false,
            selectedPanelId: "cr",
            portalClientSelectionDialog: null,
            portalClientSelectionList: null
        };
        this.modalRef = React.createRef();
        this.inputsPairingRemoteControlRef = Array.from({ length: 5 }, () => React.createRef());
        this.videoSharescreenRef = React.createRef();
        this.canvasRecorderSharescreenRef = React.createRef();
        this.chunksRef = React.createRef();
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.recordingTimeout = null;
    }


    componentDidMount() {
        this.props.changeAppBarTitle(strings.callLink);
        this.props.ChangeCurrentMenuName("callLink");
        const opconnectconfig = this.props.currentuser.currentorganization.organizationParameters.find(op => op.key === "Public-PeerConnectionConfiguration");

        try {
            window.addEventListener("resize", this.handleWindowResize);
            // Initial call for have size in beginning
            this.handleWindowResize();
            // Detect keydown and keyup for remote control
            window.addEventListener("keydown", this.handleKeyDown);
            window.addEventListener("keyup", this.handleKeyUp);
        }
        catch {}

        this.setState({
            //shareScreenConfiguration: opconnectconfig && opconnectconfig.value === "STUN" ? appSettings.ShareScreenConfigurationStun : appSettings.ShareScreenConfigurationTurn,
            currentDateTimer: setInterval(() => this.setState({ currentDate: new Date() }), 1000),
            currentSession: this.props.communication.callSession
        });
        if (this.state.isRecording) {
            this.startRecordSharescreen();
        }
    }
    componentWillUnmount() {
        clearInterval(this.state.currentDateTimer);

        try {
            window.removeEventListener("resize", this.handleWindowResize);
            // Detect keydown and keyup for remote control
            window.addEventListener("keydown", this.handleKeyDown);
            window.addEventListener("keyup", this.handleKeyUp);
        }
        catch {}

        this.onStopScreenShare();
        if (this.state.currentSession) {
            this.onChangeResource("screenAgent", "isEnabled", false);
            this.onChangeResource("mainTools", "shareScreen", false);
        }
        this.stopListeningToSessionEvents();
        this.leaveRoom();
        this.onCloseCurrentSession();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isDisplaySharescreenClient && prevState.isDisplaySharescreenClient !== this.state.isDisplaySharescreenClient) {
            if (Object.keys(this.remoteParticipantsRef).length > 0) {
                Object.values(this.remoteParticipantsRef).forEach((participant) => {
                    const divRemoteScreenClient = document.querySelector("#remoteScreenClient");
                    if (participant.clientType === "ScreenClient" && divRemoteScreenClient) {
                        divRemoteScreenClient.srcObject = participant.remoteStream;
                    }
                });
            }
        }
        if (prevState.isRecording !== this.state.isRecording) {
            if (this.state.isRecording) {
                this.startRecordSharescreen();
            }
            else {
                this.stopRecordSharescreen();
            }
        }

        const SignalResources = this.state.currentSession && this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
        const shareResourcesRaw = SignalResources && SignalResources.shareResources && SignalResources.shareResources.Data;
        const clientShareResourcesRaw = SignalResources && SignalResources.clientShareResources && SignalResources.clientShareResources.Data;

        const resourceList = shareResourcesRaw ? JSON.parse(shareResourcesRaw) : [];
        const clientResourceList = clientShareResourcesRaw ? JSON.parse(clientShareResourcesRaw) : [];

        const total = resourceList.length + clientResourceList.length;

        if (this.state.totalAttachments !== total) {
            this.setState({ totalAttachments: total });
        }

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.communication.webRTConnection !== null && this.state.webRTConnection === null) {
            this.setState({ webRTConnection: nextProps.communication.webRTConnection });
            this.listenToSessionEvents(nextProps.communication.webRTConnection);
        }
        if ( nextProps.communication.callSession !== null && (!this.state.currentSession || this.state.currentSession.IdRoom !== nextProps.communication.callSession.IdRoom)) {
            this.onChangeSession(nextProps.communication.callSession);
        }
        else if ( nextProps.communication.callSession != null && nextProps.communication.callSession.status !== this.state.currentSession.status) {
            this.setState({
                currentSession: {
                    ...this.state.currentSession,
                    status: nextProps.communication.callSession.status
                } });
        }
        else if (nextProps.communication.callSession === null && this.state.currentSession) {
            this.onEndCurrentCall(() => {});
        }
        else if (nextProps.communication.callSession != null && this.state.currentSession != null && this.state.currentSession.SharedResources !== nextProps.communication.callSession.SharedResources ) {
            const prevResources = this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
            const nextResources = nextProps.communication.callSession.SharedResources ? JSON.parse(nextProps.communication.callSession.SharedResources) : null;

            if (nextResources && prevResources && nextResources.payment.responseForConsent !== prevResources.payment.responseForConsent) {
                const currentConsent = this.state.consent;
                currentConsent.isAccepted = nextResources.payment.responseForConsent.toString() === "true";
                this.setState({
                    isDisplayRefusedConsent: !currentConsent.isAccepted,
                    consent: currentConsent
                });
                this.formatDateConsent("responseForConsent");
                console.log("[signalR] - responseForConsent received for credit card:", nextResources.payment.responseForConsent);
            }
            if (nextResources && prevResources && nextResources.mainTools.payment !== prevResources.mainTools.payment) {
                if (this.state.isSendRequestForConsent && (this.state.consent.isAccepted || this.state.isDisplayRefusedConsent)) {
                    this.handleSendPaymentConsent();
                    setTimeout(() => {
                        this.setState((prevState) => ({
                            isSendRequestForConsent: false,
                            isDisplayRefusedConsent: false,
                            consent: {
                                subject: "",
                                clientName: "",
                                dateRequestConsent: "",
                                dateResponseConsent: "",
                                isAccepted: false
                            }
                        }));
                    }, 600);
                }
            }
            if (nextResources && prevResources && nextResources.screenCallApp.isEnabled !== prevResources.screenCallApp.isEnabled) {
                this.setState({
                    srcSharescreenClient: JSON.parse(nextResources.screenCallApp.isEnabled),
                    isDisplaySharescreenClient: JSON.parse(nextResources.screenCallApp.isEnabled),
                    showPairingCodeDialog: false
                });
            }

            this.setState({
                currentSession: {
                    ...this.state.currentSession,
                    SharedResources: nextProps.communication.callSession.SharedResources
                }
            });
        }
    }

    //#region functions
    onCloseCurrentSession(onSuccess) {
        const currentPortalAgent = this.props.communication && this.props.communication.linkedPortalAgent;
        const orgId = this.props.currentuser && this.props.currentuser.currentorganization ? this.props.currentuser.currentorganization.id : null;
        const orgUser = orgId ? this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId) : null;

        if (this.state.currentSession) {
            const calllogData = {
                notes: this.state.callnotes,
                categoryId: this.state.selectedCallCategorie ? this.state.selectedCallCategorie.id : null
            };

            this.props.EditCallLogData(
                this.state.currentSession.IdRoom,
                calllogData,
                () => {
                    this.setState({
                        currentSession: null,
                        selectedCallCategorie: null,
                        selectedAttachment: null,
                        selectedPanelId: "cr",
                        callnotes: ""
                    });
                    if (onSuccess) {
                        onSuccess();
                    }
                }
            );
        }
        else {
            this.setState({
                currentSession: null,
                selectedCallCategorie: null,
                selectedAttachment: null,
                selectedPanelId: "cr",
                callnotes: ""
            });
            if (onSuccess) {
                onSuccess();
            }
        }
    }
    onEndCurrentCall(onSuccess) {
        const curSession = { ...this.state.currentSession };
        const SignalResources = JSON.parse(curSession.SharedResources);

        //we update/clean the currentSession
        curSession.isCallClose = true;
        curSession.sessionDuration = Math.floor((this.state.currentDate - new Date(this.state.currentSession.CallStartingTime)) / 1000);
        SignalResources.screenAgent.isEnabled = false;
        SignalResources.mainTools.payment = false;
        SignalResources.mainTools.shareScreen = false;

        curSession.SharedResources = JSON.stringify(SignalResources);
        this.setState({ currentSession: curSession, selectedPanelId: "cr" });
        if (onSuccess) {
            onSuccess();
        }
    }
    onChangeSession(newSession) {
        this.onCloseCurrentSession(() => {
            if (newSession != null) {
                this.setState({
                    currentSession: newSession,
                    selectedCallCategorie: null,
                    selectedAttachment: null,
                    callnotes: "",
                    callcategory: null,
                    isSendRequestForConsent: false,
                    isDisplayRefusedConsent: false,
                    formatedDateRequestConsent: "",
                    formatedResponseForConsent: "",
                    consent: {
                        subject: "",
                        clientName: "",
                        dateRequestConsent: "",
                        dateResponseConsent: "",
                        isAccepted: false
                    },
                    isOpenModalCallCategories: false,
                    srcSharescreenClient: false,
                    isDisplaySharescreenClient: false,
                    counterRecorder: 0,
                    counterScreenshot: 0,
                    showPairingCodeDialog: false,
                    showErrorMessagePairingCode: false,
                    showErrorMessagePairingCodeAlreadyUsed: false,
                    codePairingRemoteControl: "",
                    displayButtonStopRemoteControl: false,
                    isRemoteControlStarted: false
                });
            }
        });
    }
    async onScreenShare() {
        console.log("onScreenShare");

        let mediaStream = null;
        this.onStopScreenShare();


        const constraints = {
            video: {
                //width: { max: 1280 },
                //height: { max: 720 },
                width: { max: 1920 },
                height: { max: 1080 },
                frameRate: { ideal: 30, max: 30 }
            },
            audio: false
        };



        try {
            if (navigator.getDisplayMedia) {
                mediaStream = await navigator.getDisplayMedia(constraints);
            }
            else if (navigator.mediaDevices.getDisplayMedia) {
                mediaStream = await navigator.mediaDevices.getDisplayMedia(constraints);
            }

            mediaStream.getVideoTracks()[0].addEventListener("ended", () => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - The user has ended sharing the screen");
                this.onChangeResource("screenAgent", "isEnabled", false);
                this.onChangeResource("mainTools", "shareScreen", false);
            });

            this.setState({ mediaStream: mediaStream });
            this.joinRoom();
        }
        catch (exceptionVar) {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - The user canceled screenshare");
            this.onChangeResource("screenAgent", "isEnabled", false);
            this.onChangeResource("mainTools", "shareScreen", false);
        }
    }
    onStopScreenShare() {
        const stream = this.state.mediaStream;
        if (stream !== null && stream !== undefined) {
            const tracks = stream.getTracks();
            tracks.forEach((track) => {
                track.stop();
            });
        }
    }
    onSelectCategory(category) {
        if (!this.state.currentSession.isCallClose) {
            const connection = this.state.webRTConnection;
            if (connection && this.state.currentSession) {
                connection.invoke("SendCategRoomSession", this.state.currentSession.IdRoom, category.id.toString()).then(() => {
                    const dateLogs = new Date().toISOString();
                    console.log(`[${dateLogs}]`, "[signalR] - invoke ==> SendCategRoomSession", category.id.toString() + " ; " + category.name.toString() + ";");
                    this.setState({
                        isOpenModalCallCategories: false,
                        selectedCallCategorie: category
                    });
                });
            }
        }
        else {
            this.setState({
                isOpenModalCallCategories: false,
                selectedCallCategorie: category
            });
        }
    }
    onChangeResource(resourceTitle, resourceName, resourceValue) {
        const SignalResources = this.state.currentSession && this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
        const connection = this.state.webRTConnection;
        if (SignalResources[resourceTitle][resourceName] === resourceValue) {return;}
        if (connection && this.state.currentSession) {
            connection.invoke("ChangeSharedResources", this.state.currentSession.IdRoom, resourceTitle, resourceName, resourceValue.toString()).then(() => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - invoke ==> ChangeSharedResources", resourceTitle + " ; " + resourceName + ";" + resourceValue.toString());
                if (resourceTitle === "screenAgent") {
                    if (resourceValue) {this.onScreenShare();}
                    else {
                        this.onStopScreenShare();
                        this.leaveRoom();
                        this.setState({ mediaStream: null });
                    }
                }
            });
        }
        SignalResources[resourceTitle][resourceName] = resourceValue;
        this.props.EditCallSessionResources(JSON.stringify(SignalResources));
    }
    addDocumentToTempResource(files) {
        if (files.length <= 0) {return;}

        const file = files[0];
        const tempResource = this.state.tempResource;
        const forbidden = ["exe", "rar", "zip", "js"];
        const strFile = file.name;
        const typeFile = strFile.split(".").splice(1).join(".");

        if (forbidden.includes(typeFile)) {
            this.props.OpenDialog({
                title: "Mauvaise extension",
                description: "Pour des raisons de sécurité, vous ne pouvez pas charger de fichiers de type ." + typeFile,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        if (file.size > this.props.configuration.multipartBodyLengthLimit) {
            this.props.OpenDialog({
                title: strings.fileTooBig,
                description: strings.fileTooBigDesc + this.props.configuration.multipartBodyLengthLimit / 1000000 + "MB",
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        tempResource.type = "doc";
        tempResource.name = file.name;
        tempResource.url = null;

        this.setState({ tempResource: tempResource, loadingFile: true });

        this.props.SaveTemporaryDocument( file,
            (newfileurl) => {
                console.log("share new document", newfileurl);
                tempResource.url = newfileurl;
                this.setState({
                    shareResourceListSelected: null,
                    tempResource: tempResource,
                    loadingFile: false
                });
            }
        );
    }

    //peerConnection
    registerPeerConnectionListeners(peerConnection) {
        peerConnection.addEventListener("connectionstatechange", () => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[webRTC] - Connection state change: ", peerConnection.connectionState);
            if (peerConnection.connectionState === "failed") {
                peerConnection.restartIce();
            }
        });
        peerConnection.addEventListener("iceconnectionstatechange ", () => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[webRTC] - ICE connection state change: ", peerConnection.iceConnectionState);
            if (peerConnection.iceConnectionState === "failed") {
                peerConnection.restartIce();
            }
        });
    }

    //signalrEvents
    async listenToSessionEvents(connection) {
        if (connection !== null) {
            connection.on("OnParticipantAdded", async (idParticipant, idRoom, clientType, isExisting) => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - ==> OnParticipantAdded");

                const isScreenClient = clientType === "ScreenClient";

                //Save the new participant
                const remoteParticipants = this.state.remoteParticipants;
                if (remoteParticipants[idParticipant] === undefined || remoteParticipants[idParticipant] === null) {
                    remoteParticipants[idParticipant] = {
                        clientType: clientType,
                        peerConnection: null,
                        remoteStream: null
                    };
                }

                if (this.state.mediaStream !== null) {
                    //If the new participant has been added during a stream, we open the stream to him

                    //close the old PeerConnection
                    if (remoteParticipants[idParticipant].peerConnection !== null) {
                        remoteParticipants[idParticipant].peerConnection.close();
                        remoteParticipants[idParticipant].peerConnection = null;
                    }
                    //Create PeerConnection with configuration
                    const peerConnection = new RTCPeerConnection(this.state.shareScreenConfiguration);
                    this.registerPeerConnectionListeners(peerConnection);
                    this.state.mediaStream.getTracks().forEach(track => {
                        peerConnection.addTrack(track, this.state.mediaStream);
                    });
                    remoteParticipants[idParticipant].peerConnection = peerConnection;
                }

                if (isScreenClient) {

                    console.log(`[${dateLogs}]`, "[webRTC] - Create PeerConnection with configuration:", this.state.shareScreenConfiguration);

                    const peerConnection = new RTCPeerConnection(this.state.shareScreenConfiguration);

                    this.registerPeerConnectionListeners(peerConnection);

                    // Create dummy track audio
                    const ctx = new AudioContext();
                    const oscillator = ctx.createOscillator();
                    const dst = oscillator.connect(ctx.createMediaStreamDestination());
                    oscillator.start();
                    const silentAudioTrack = dst.stream.getAudioTracks()[0];

                    // Create dummy video track ( black canvas)
                    const canvas = document.createElement("canvas");
                    canvas.width = 1;
                    canvas.height = 1;
                    const ctxCanvas = canvas.getContext("2d");

                    ctxCanvas.fillStyle = "black";
                    ctxCanvas.fillRect(0, 0, canvas.width, canvas.height);

                    const videoStream = canvas.captureStream();
                    const emptyVideoTrack = videoStream.getVideoTracks()[0];

                    peerConnection.addTrack(emptyVideoTrack, videoStream);
                    peerConnection.addTrack(silentAudioTrack, dst.stream);

                    this.remoteParticipantsRef[idParticipant] = {
                        clientType,
                        peerConnection,
                        remoteStream: new MediaStream()
                    };

                    this.setState({ remoteParticipants: { ...this.remoteParticipantsRef } });


                    console.log(`[${dateLogs}]`, "[inui] - remoteParticipants updated:", this.remoteParticipantsRef);

                    // Listen to the "track" event for receiving new remote tracks
                    peerConnection.addEventListener("track", event => {
                        console.log(`[${dateLogs}]`, "[webRTC] - Got remote track:", event.streams[0]);

                        event.streams[0].getTracks().forEach(track => {
                            console.log(`[${dateLogs}]`, "[webRTC] - Add a track to the remoteStream:", track);

                            // Adds the track to the participant's remote stream
                            this.remoteParticipantsRef[idParticipant].remoteStream.addTrack(track);

                            this.setState(prevState => {
                                const updatedRemoteStream = this.remoteParticipantsRef[idParticipant].remoteStream;
                                updatedRemoteStream.addTrack(track);
                                this.remoteParticipantsRef[idParticipant] = {
                                    ...this.remoteParticipantsRef[idParticipant],
                                    remoteStream: updatedRemoteStream
                                };
                            });
                        });
                    });
                }

                this.setState({ remoteParticipants: remoteParticipants });
            });
            connection.on("OnParticipantRemoved", (idParticipant) => {
                const clientType = this.state.remoteParticipants[idParticipant].clientType;
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - ==> OnParticipantRemoved idParticpantRemoved:", idParticipant, "clientType", clientType);
                this.onStopScreenShare();

                const remoteParticipants = this.state.remoteParticipants;
                if (remoteParticipants[idParticipant] === undefined || remoteParticipants[idParticipant] === null) {return;}

                if (remoteParticipants[idParticipant] && remoteParticipants[idParticipant].peerConnection) {
                    console.log(`[${new Date().toISOString()}] [webRTC] - Closing old PeerConnection for participant:`, idParticipant);
                    remoteParticipants[idParticipant].peerConnection.close();
                    remoteParticipants[idParticipant].peerConnection = null;
                }
                remoteParticipants[idParticipant] = null;
                this.setState({ currentRoom: null });

                if (clientType === "ScreenClient") {

                    document.querySelector("#remoteScreenClient").srcObject.getTracks().forEach(track => track.stop());
                    document.querySelector("#remoteScreenClient").srcObject = null;

                    this.setState({
                        srcSharescreenClient: false,
                        isDisplaySharescreenClient: false,
                        showPairingCodeDialog: false,
                        showErrorMessagePairingCode: false,
                        showErrorMessagePairingCodeAlreadyUsed: false,
                        codePairingRemoteControl: ""
                    });

                    if (isRemoteControlStarted) {
                        this.stopRemoteControl();
                    }
                }
            });
            connection.on("OnReceivedCallRequest", async (uIdParticipantFrom, idRoom, autoStart, responseDecisionTree, isReconnecting, isCallTransfer, isCallApp) => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - OnReceivedCallRequest, uIdParticipantFrom: ", uIdParticipantFrom);

                setTimeout(async () => {
                    // Code for creating offer
                    const remoteParticipants = this.remoteParticipantsRef;
                    console.log("remoteParticipants", remoteParticipants);
                    const pc = remoteParticipants[uIdParticipantFrom].peerConnection;
                    const offer = await pc.createOffer();
                    await pc.setLocalDescription(offer);
                    console.log(`[${dateLogs}]`, "[webRTC] - Created offer:", offer);

                    console.log("Sending offer to participant...");
                    await connection.send("SendOffer", offer, uIdParticipantFrom);
                    console.log("Offer successfully sent.");

                    // Code for collecting ICE candidates below
                    pc.addEventListener("icecandidate", async (event) => {
                        const dateLogs = new Date().toISOString();
                        console.log(`[${dateLogs}]`, "[webRTC] - Icecandidate received");
                        if (event.candidate) {
                            try {
                                console.log(`[${new Date().toISOString()}] [SignalR] - Sending ICE candidate...`);
                                await connection.send("SendOfferCandidates", event.candidate.toJSON(), uIdParticipantFrom);
                                console.log(`[${new Date().toISOString()}] [SignalR] - ICE candidate sent successfully!`);
                            }
                            catch (error) {
                                console.error(`[${new Date().toISOString()}] [SignalR] - Error sending ICE candidate:`, error);
                            }
                        }
                        if (!event.candidate) {
                            console.log(`[${dateLogs}]`, "[webRTC] - Got final candidate!");
                            return;
                        }
                        console.log(`[${dateLogs}]`, "[webRTC] - Got candidate:", event.candidate);
                        console.log(`[${dateLogs}]`, "[signalR] - SendOfferCandidates");

                        // Send offer to remote participant
                        await connection.send("SendOfferCandidates", event.candidate.toJSON(), uIdParticipantFrom);
                    });
                }, 2000);
            });
            connection.on("OnReceivedNewAnswer", async (answer, uIdParticipantFromAnswer) => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - OnReceivedNewAnswer:", "Got remote description: ", answer);
                const remoteParticipants = this.remoteParticipantsRef;
                const pc = remoteParticipants[uIdParticipantFromAnswer].peerConnection;
                if (!pc.currentRemoteDescription && answer) {
                    const rtcSessionDescription = new RTCSessionDescription(answer);
                    // Setting the remote description with the received answer
                    await pc.setRemoteDescription(rtcSessionDescription);
                    console.log("setRemoteDescription completed");
                }
            });
            connection.on("OnReceivedNewOffer", async (offer, idParticipantFromOffer) => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - ===> OnReceivedNewOffer", "Offer:", offer);
                const remoteParticipants = this.state.remoteParticipants;
                if ( remoteParticipants[idParticipantFromOffer] !== null
                    && remoteParticipants[idParticipantFromOffer] !== undefined
                    && remoteParticipants[idParticipantFromOffer].peerConnection !== null ) {
                    const pc = remoteParticipants[idParticipantFromOffer].peerConnection;
                    if (offer) {
                        await pc.setRemoteDescription(new RTCSessionDescription(offer));
                        const answer = await pc.createAnswer();
                        await pc.setLocalDescription(answer);
                        await connection.send("SendAnswer", answer, idParticipantFromOffer);
                    }
                    pc.addEventListener("icecandidate", async(event) => {
                        if (!event.candidate) {
                            return;
                        }
                        await connection.send("SendAnswerCandidates", event.candidate.toJSON(), idParticipantFromOffer);
                    });
                    this.setState({ remoteParticipants: remoteParticipants });
                }
            });
            connection.on("OnReceivedOfferCandidate", async (offerCandidate, idParticipantFromOffer) => {
                const remoteParticipants = this.state.remoteParticipants;
                if ( remoteParticipants[idParticipantFromOffer] !== null
                    && remoteParticipants[idParticipantFromOffer] !== undefined
                    && remoteParticipants[idParticipantFromOffer].peerConnection !== null ) {
                    const pc = remoteParticipants[idParticipantFromOffer].peerConnection;
                    const dateLogs = new Date().toISOString();
                    console.log(`[${dateLogs}]`, "[signalR] - ===> OnReceivedOfferCandidate");
                    pc.addIceCandidate(new RTCIceCandidate(offerCandidate));
                }
            });
            connection.on("OnReceivedAnswerCandidate", async (answerCandidate, uIdParticipantFromAnswerC) => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - OnReceivedAnswerCandidate:", "Got new remote ICE candidate: ", answerCandidate);
                try {
                    const remoteParticipants = this.remoteParticipantsRef || this.state.remoteParticipants;

                    if (!uIdParticipantFromAnswerC) {
                        throw new Error("❌ uIdParticipantFromAnswerC is undefined!");
                    }

                    const pc = remoteParticipants[uIdParticipantFromAnswerC] && remoteParticipants[uIdParticipantFromAnswerC].peerConnection;

                    if (!pc) {
                        throw new Error(`[${new Date().toISOString()}] [webRTC] - ❌ PeerConnection not found for participant: ${uIdParticipantFromAnswerC}`);
                    }

                    if (pc.connectionState === "closed" || pc.iceConnectionState === "failed") {
                        throw new Error(`[${dateLogs}] -  [webRTC] - ❌ PeerConnection is in a failed/closed state!`);
                    }

                    if (answerCandidate) {
                        console.log(`[${dateLogs}] -  [webRTC] - Adding ICE candidate...`);
                        await pc.addIceCandidate(new RTCIceCandidate(answerCandidate));
                        console.log(`[${dateLogs}] -  [webRTC] - ICE candidate added successfully.`);
                    }
                }
                catch (error) {
                    console.error(`[${dateLogs}] -  [webRTC] - ❌ Critical error in OnReceivedAnswerCandidate:`, error);
                }
            });
            connection.on("onremotecontrolstarted", async () => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - onremotecontrolstarted received");
                this.setState({
                    displayButtonStopRemoteControl: true,
                    showPairingCodeDialog: false,
                    isRemoteControlStarted: true
                });
            });
            connection.on("OnRemoteControlStopped", async (isStoppedByUser) => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - OnRemoteControlStopped received", "isStoppedByUser: ", isStoppedByUser);
                this.setState({
                    showPairingCodeDialog: false,
                    showErrorMessagePairingCode: false,
                    showErrorMessagePairingCodeAlreadyUsed: false,
                    codePairingRemoteControl: "",
                    displayButtonStopRemoteControl: false,
                    isRemoteControlStarted: false
                });

                if (!isStoppedByUser) {
                    this.setState({
                        showMessageRemoteControlCrashed: true
                    });
                }
            });

            this.setState({ webRTConnection: connection });
        }
    }
    async stopListeningToSessionEvents() {
        const connection = this.state.webRTConnection;
        if (connection !== null) {
            connection.off("OnParticipantAdded");
            connection.off("OnParticipantRemoved");
            connection.off("OnReceivedCallRequest");
            connection.off("OnReceivedNewAnswer");
            connection.off("OnReceivedNewOffer");
            connection.off("OnReceivedOfferCandidate");
            connection.off("OnReceivedAnswerCandidate");
            this.setState({ webRTConnection: connection });
        }
    }
    async joinRoom() {
        const dateLogs = new Date().toISOString();
        console.log(`[${dateLogs}]`, "[signalR] - ==> invoke joinRoom");
        const connection = this.state.webRTConnection;
        const callSession = this.state.currentSession;
        if (callSession == null || connection == null) {
            console.log(`[${dateLogs}]`, "[signalR] - there is no room to join");
            return;
        }
        if (this.state.currentRoom !== null) {
            console.log(`[${dateLogs}]`, "[signalR] - we are already in a room");
            return;
        }
        await connection.invoke("JoinRoom", callSession.IdRoom).then(() => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - room joined");
            this.setState({ currentRoom: {} });
        });

    }
    async leaveRoom() {
        const dateLogs = new Date().toISOString();
        console.log(`[${dateLogs}]`, "[signalR] - ==> invoke leaveRoom");
        const connection = this.state.webRTConnection;
        const callSession = this.state.currentSession;
        if (!callSession || !connection || !callSession.IdRoom) {
            console.log(`[${dateLogs}]`, "[signalR] - there is no room to leave");
            this.setState({ currentRoom: null });
            return;
        }
        await connection.invoke("LeaveRoom", callSession.IdRoom, "SkaPilot").then(() => {
            console.log(`[${dateLogs}]`, "[signalR] - room left");
            this.setState({ currentRoom: null });
        });
    }

    handleClickSendConsentCreditCard() {
        const connection = this.state.webRTConnection;
        connection.invoke("ChangeSharedResources", this.state.currentSession.IdRoom, "payment", "requestForConsent", "true").then(() => {
            this.setState({
                isSendRequestForConsent: true,
                isDisplayRefusedConsent: false
            });
            this.formatDateConsent("requestForConsent");
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - invoke ==> ChangeSharedResources", "key: ", "payment", " property: ", "requestForConsent", " value:", "true");
        });
    }

    async closePaymentToggle() {
        const SignalResources = this.state.currentSession && this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
        const newvalue = !SignalResources || SignalResources.mainTools.payment.toString() === "false" ? true : false;
        this.onChangeResource("mainTools", "payment", newvalue);

        if (newvalue === false) {
            // Verify there are date request and date consent accepted or refused
            if (newvalue === false && this.state.isSendRequestForConsent && (this.state.consent.isAccepted || this.state.isDisplayRefusedConsent)) {
                await this.handleSendPaymentConsent();
            }

            // Clean container payment
            this.setState({
                isSendRequestForConsent: false,
                isDisplayRefusedConsent: false,
                consent: {
                    subject: "",
                    clientName: "",
                    dateRequestConsent: "",
                    dateResponseConsent: "",
                    isAccepted: false
                }
            });
        }
    }

    async handleSendPaymentConsent() {
        const isSuccess = await this.props.SendPaymentConsent(this.state.consent);
        if (isSuccess) {
            console.log("Consent payment was sent successfully.");
            // Clean state of request consent
            this.setState({
                isSendRequestForConsent: false,
                formatedDateRequestConsent: "",
                formatedResponseForConsent: "",
                consent: {
                    subject: "",
                    clientName: "",
                    dateRequestConsent: "",
                    dateResponseConsent: "",
                    isAccepted: false
                }
            });
        }
        else {
            console.log("Failed to send consent payment.");
        }
    }

    formatDateConsent(isRequestOrResponseConsent) {
        const date = new Date();
        const currentConsent = this.state.consent;
        if (isRequestOrResponseConsent === "requestForConsent") {
            currentConsent.dateRequestConsent = date.toISOString();
            this.setState({ consent: currentConsent });
        }
        else {
            currentConsent.dateResponseConsent = date.toISOString();
            this.setState({ consent: currentConsent });
        }

        const dateOptions = {
            day: "numeric",
            month: "long",
            year: "numeric"
        };

        const timeOptions = {
            hour: "2-digit",
            minute: "2-digit"
        };

        const dateString = date.toLocaleDateString("fr-FR", dateOptions);
        const timeString = date.toLocaleTimeString("fr-FR", timeOptions).replace(":", "h");
        if (isRequestOrResponseConsent === "requestForConsent") {
            this.setState({ formatedDateRequestConsent: `${dateString} · ${timeString}` });
        }
        else {
            this.setState({ formatedResponseForConsent: `${dateString} · ${timeString}` });
        }
        const formattedDate = `${dateString} · ${timeString}`;
        return formattedDate;

    }

    async sendRemoteControlRequest(windowsOS) {
        const connection = this.state.webRTConnection;
        await connection.invoke("SendRemoteControlRequest", windowsOS)
            .then((result) => {
                const dateLogs = new Date().toISOString();
                if (result && result.success === true) {
                    console.log(`[${dateLogs}]`, "[signalR] - SUCCESS invoke ==> SendRemoteControlRequest", "windowsOS: ", windowsOS);
                    this.setState({ showPairingCodeDialog: true });
                }
                else {
                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlRequest", "windowsOS: ", windowsOS, "result: ", result);
                }
            })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlRequest", "windowsOS: ", windowsOS, "Error: ", error);
            });
    }

    handleChangeInputCodeRemoteControl(value, index) {
        if (!/^[0-9]?$/.test(value)) {return;}

        let code = this.state.codePairingRemoteControl.padEnd(5, " ");
        code = code.substring(0, index) + value + code.substring(index + 1);

        this.setState({ codePairingRemoteControl: code }, () => {
            if (value && index < 4) {
                const nextInputRef = this.inputsPairingRemoteControlRef[index + 1];
                if (nextInputRef && nextInputRef.current) {
                    nextInputRef.current.focus();
                }
            }
        });
    }

    handleKeyDownInputCodeRemoteControl(e, index) {
        if (e.key === "Backspace") {
            const code = this.state.codePairingRemoteControl.padEnd(5, " ");
            if (!code.charAt(index) && index > 0) {
                const nextInput = this.inputsPairingRemoteControlRef[index + 1];
                if (nextInput && nextInput.current) {
                    nextInput.current.focus();
                }
            }
        }
    }

    async startingRemoteControl() {
        const connection = this.state.webRTConnection;
        const videoElement = this.videoSharescreenRef.current;

        await connection.invoke("StartRemoteControl", this.state.codePairingRemoteControl)
            .then((result) => {
                const dateLogs = new Date().toISOString();
                if (result && result.success === true) {
                    console.log(`[${dateLogs}]`, "[signalR] - SUCCESS invoke ==> StartRemoteControl", "codePairingRemoteControl: ", this.state.codePairingRemoteControl);
                    // Send width and heigh of video sharescreen
                    // Wait for video has his metadata downloaded
                    const waitForVideoMetadata = new Promise((resolve) => {
                        if (videoElement.readyState >= 1) {
                        // metadata already available
                            resolve();
                        }
                        else {
                            videoElement.addEventListener("loadedmetadata", resolve, { once: true });
                        }
                    });

                    waitForVideoMetadata.then(() => {
                        const rect = videoElement.getBoundingClientRect();
                        const widthSharescreenClient = Math.round(rect.width);
                        const heightSharescreenClient = Math.round(rect.height);

                        connection.invoke("InitializeRemoteDisplayParameter", widthSharescreenClient, heightSharescreenClient)
                            .then((resultInitializeRemote) => {
                                if (resultInitializeRemote && resultInitializeRemote.success === true) {
                                    console.log(`[${dateLogs}]`, "[signalR] - SUCCESS invoke ==> InitializeRemoteDisplayParameter", "widthSharescreenClient: ", widthSharescreenClient, "heightSharescreenClient: ", heightSharescreenClient);
                                }
                                else {
                                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> InitializeRemoteDisplayParameter", resultInitializeRemote);
                                }
                            })
                            .catch((errorInitializeRemote) => {
                                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> InitializeRemoteDisplayParameter", errorInitializeRemote);
                            });
                    });
                }
                else {
                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> StartRemoteControl", "codePairingRemoteControl: ", this.state.codePairingRemoteControl, "result: ", result);
                    if (result.success === false && result.code === "NO_REMOTE_CONTROLLER_FOUND") {
                        this.setState({ showErrorMessagePairingCode: true });
                    }
                    else if (result.success === false && result.code === "REMOTE_CONTROLLER_IN_USED") {
                        this.setState({ showErrorMessagePairingCodeAlreadyUsed: true });
                    }
                }
            })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> StartRemoteControl", "codePairingRemoteControl: ", this.state.codePairingRemoteControl, "Error: ", error);
            });
    }

    handleWindowResize() {
        if (this.state.isRemoteControlStarted) {
            const video = this.videoSharescreenRef.current;
            if (video) {
                const rect = video.getBoundingClientRect();
                const widthSharescreenClient = Math.round(rect.width);
                const heightSharescreenClient = Math.round(rect.height);

                const connection = this.state.webRTConnection;
                connection.invoke("InitializeRemoteDisplayParameter", widthSharescreenClient, heightSharescreenClient)
                    .then((resultInitializeRemote) => {
                        const dateLogs = new Date().toISOString();
                        if (resultInitializeRemote && resultInitializeRemote.success === true) {
                            console.log(`[${dateLogs}]`, "[signalR] - SUCCESS invoke ==> InitializeRemoteDisplayParameter because user resize his browser", "widthSharescreenClient: ", widthSharescreenClient, "heightSharescreenClient: ", heightSharescreenClient);
                        }
                        else {
                            console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> InitializeRemoteDisplayParameter because user resize his browser", resultInitializeRemote);
                        }
                    })
                    .catch((errorInitializeRemote) => {
                        const dateLogs = new Date().toISOString();
                        console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> InitializeRemoteDisplayParameter because user resize his browser", errorInitializeRemote);
                    });
            }
        }
    }

    async stopRemoteControl() {
        const connection = this.state.webRTConnection;
        await connection.invoke("StopRemoteControl")
            .then((result) => {
                const dateLogs = new Date().toISOString();
                if (result && result.success === true) {
                    console.log(`[${dateLogs}]`, "[signalR] - SUCCESS invoke ==> StopRemoteControl");
                }
                else {
                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> StopRemoteControl", "result: ", result);
                }
            })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> StopRemoteControl", "codePairingRemoteControl: ", "Error: ", error);
            });
    }

    async handleMouseDown(e) {
        const connection = this.state.webRTConnection;

        const video = this.videoSharescreenRef.current;
        const rect = video.getBoundingClientRect();
        const clientX = e.clientX - rect.left;
        const clientY = e.clientY - rect.top;

        await connection.invoke("SendRemoteControlData", "Pressed", Math.round(clientX), Math.round(clientY), "")
            .then((result) => {
                const dateLogs = new Date().toISOString();
                if (result && result.success === false) {
                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlData", "MouseDown: Pressed", "result: ", result);
                }
            })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlData", "MouseDown: Pressed", "Error: ", error);
            });
    }


    async handleMouseMove(e) {
        const connection = this.state.webRTConnection;

        const video = this.videoSharescreenRef.current;
        const rect = video.getBoundingClientRect();
        const clientX = e.clientX - rect.left;
        const clientY = e.clientY - rect.top;

        await connection.invoke("SendRemoteControlData", "Move", Math.round(clientX), Math.round(clientY), "").then((result) => {
            const dateLogs = new Date().toISOString();
            if (result && result.success === false) {
                console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlData", "MouseMove: Move", "result: ", result);
            }
        })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlData", "MouseMove: Move", "Error: ", error);
            });
    }

    async handleMouseUp(e) {
        const connection = this.state.webRTConnection;

        const video = this.videoSharescreenRef.current;
        const rect = video.getBoundingClientRect();
        const clientX = e.clientX - rect.left;
        const clientY = e.clientY - rect.top;

        await connection.invoke("SendRemoteControlData", "Released", Math.round(clientX), Math.round(clientY), "").then((result) => {
            const dateLogs = new Date().toISOString();
            if (result && result.success === false) {
                console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlData", "MouseUp: Released", "result: ", result);
            }
        })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlData", "MouseUp: Released", "Error: ", error);
            });
    }

    async handleMouseRightClick(e) {
        e.preventDefault();

        const connection = this.state.webRTConnection;

        const video = this.videoSharescreenRef.current;
        const rect = video.getBoundingClientRect();
        const clientX = e.clientX - rect.left;
        const clientY = e.clientY - rect.top;

        await connection.invoke("SendRemoteControlData", "RightPressed", Math.round(clientX), Math.round(clientY), "").then((result) => {
            const dateLogs = new Date().toISOString();
            if (result && result.success === false) {
                console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlData", "MouseRightClick: RightPressed", "result: ", result);
            }
        })
            .catch((error) => {
                const dateLogs = new Date().toISOString();
                console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlData", "MouseRightClick: RightPressed", "Error: ", error);
            });
    }

    async handleKeyDown(e) {
        if (this.state.isFocusSharescreen) {
            e.preventDefault();

            const connection = this.state.webRTConnection;

            const video = this.videoSharescreenRef.current;
            const rect = video.getBoundingClientRect();
            const clientX = e.clientX - rect.left;
            const clientY = e.clientY - rect.top;

            await connection.invoke("SendRemoteControlData", "KeyDown", 0, 0, e.key).then((result) => {
                const dateLogs = new Date().toISOString();
                if (result && result.success === false) {
                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlData", "KeyDown", "result: ", result);
                }
            })
                .catch((error) => {
                    const dateLogs = new Date().toISOString();
                    console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlData", "KeyDown", "Error: ", error);
                });
        }
    }

    async handleKeyUp(e) {
        if (this.state.isFocusSharescreen) {
            e.preventDefault();

            const connection = this.state.webRTConnection;

            await connection.invoke("SendRemoteControlData", "KeyUp", 0, 0, e.key).then((result) => {
                const dateLogs = new Date().toISOString();
                if (result && result.success === false) {
                    console.error(`[${dateLogs}]`, "[signalR] - FAILED invoke ==> SendRemoteControlData", "KeyUp", "result: ", result);
                }
            })
                .catch((error) => {
                    const dateLogs = new Date().toISOString();
                    console.error(`[${dateLogs}]`, "[signalR] - ERROR invoke ==> SendRemoteControlData", "KeyUp", "Error: ", error);
                });
        }
    }


    async captureScreenshot() {
        const videoElement = this.videoSharescreenRef.current;
        if (!videoElement || videoElement.readyState < 2) {
            console.warn("Video not ready for screenshot");
            return;
        }

        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;

        const context = canvas.getContext("2d");
        context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

        const blob = await new Promise((resolve) => {
            canvas.toBlob(resolve, "image/png");
        });

        if (!blob) {
            console.error("Error when capture screenshot");
            return;
        }
        const file = new File([blob], `Capture d'écran ${this.getFormattedDate()} à ${this.getFormattedTime()}.png`, { type: "image/png" });
        const blobURL = await new Promise((resolve, reject) => {
            this.props.SaveTemporaryDocument(
                file,
                (result) => {
                    resolve(result); // onSuccess callback
                },
                (error) => {
                    reject(error); // onError callback
                }
            );
        });

        if (blobURL) {
            const SignalResources = this.state.currentSession && this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
            const prevSharedResources = SignalResources && SignalResources.clientShareResources && SignalResources.clientShareResources.Data ? JSON.parse(SignalResources.clientShareResources.Data) : [];
            const newSharedResource = {
                name: file.name,
                url: blobURL,
                type: "screenshotPilotSharescreenClient" };

            const updatedSharedResources = [...prevSharedResources, newSharedResource];

            // Send to shareRessources
            this.onChangeResource("clientShareResources", "Data", JSON.stringify(updatedSharedResources));
        }

        this.setState((prevState) => ({
            counterScreenshot: prevState.counterScreenshot + 1
        }));
    }


    async startRecordSharescreen() {
        const video = this.videoSharescreenRef.current;
        if (!video) {
            console.error("Sharescreen video is undefined");
            return;
        }

        // Record stream from sharescreen <video>
        const stream = video.captureStream(30); // 30 FPS
        const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });

        this.canvasRecorderSharescreenRef.current = recorder;
        this.chunksRef.current = [];

        recorder.ondataavailable = (e) => {
            if (e.data.size > 0) {this.chunksRef.current.push(e.data);}
        };

        recorder.onstop = async() => {
            // Clean recordingTimeout
            if (this.recordingTimeout) {
                clearTimeout(this.recordingTimeout);
                this.recordingTimeout = null;
            }

            const blob = new Blob(this.chunksRef.current, { type: "video/webm" });
            const file = new File([blob], `Enregistrement ${this.getFormattedDate()} à ${this.getFormattedTime()}.webm`, { type: "video/webm" });
            const blobURL = await new Promise((resolve, reject) => {
                this.props.SaveTemporaryDocument(
                    file,
                    (result) => {
                        resolve(result); // onSuccess callback
                    },
                    (error) => {
                        reject(error); // onError callback
                    }
                );
            });

            if (blobURL) {
                const SignalResources = this.state.currentSession && this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
                const prevSharedResources = SignalResources && SignalResources.clientShareResources && SignalResources.clientShareResources.Data ? JSON.parse(SignalResources.clientShareResources.Data) : [];
                const newSharedResource = {
                    name: file.name,
                    url: blobURL,
                    type: "PilotSharescreenClientRecorder" };

                const updatedSharedResources = [...prevSharedResources, newSharedResource];

                // Send to shareRessources
                this.onChangeResource("clientShareResources", "Data", JSON.stringify(updatedSharedResources));
            }
        };

        recorder.start();

        // Start timeout for 60 secondes
        this.recordingTimeout = setTimeout(() => {
            if (this.state.isRecording) {
                this.stopRecordSharescreen();
            }
        }, 60000);
    }

    stopRecordSharescreen() {
        if (this.canvasRecorderSharescreenRef.current) {
            this.canvasRecorderSharescreenRef.current.stop();
        }

        // Clean recordingTimeout
        if (this.recordingTimeout) {
            clearTimeout(this.recordingTimeout);
            this.recordingTimeout = null;
        }

        this.setState((prevState) => ({
            isRecording: false,
            counterRecorder: prevState.counterRecorder + 1
        }));
    }

    getFormattedDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }

    getFormattedTime() {
        const today = new Date();
        const hours = String(today.getHours()).padStart(2, "0");
        const minutes = String(today.getMinutes()).padStart(2, "0");
        const seconds = String(today.getSeconds()).padStart(2, "0");
        const formattedTime = `${hours}.${minutes}.${seconds}`;

        return formattedTime;
    }

    //#endregion

    getPanels() {
        const accessrights = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const paymentPermission = accessrights && accessrights.orgLimitations.allowRemotePayment && accessrights.hasPermission(30, "allow") > 10;
        const remoteControlPermission = accessrights && accessrights.orgLimitations.allowRemoteControl && accessrights.hasPermission(25, "allow") > 10;

        const result
        = [
            {
                id: "cr",
                title: strings.CR,
                icon: "scribble",
                onSelect: () => {

                }
            },
            {
                id: "attachments",
                title: strings.Attachments,
                icon: "paperclip",
                onSelect: () => {

                }
            },
            {
                id: "shared",
                title: strings.ShareSend,
                icon: "share",
                onSelect: () => {

                }
            }
        ];
        if (remoteControlPermission) {
            result.push( {
                id: "control",
                title: strings.Control,
                icon: "pointer",
                onSelect: () => {

                }
            });
        }
        if (paymentPermission) {
            result.push( {
                id: "payment",
                title: strings.Payment,
                icon: "creditCard",
                onSelect: () => {

                }
            });
        }
        return result;
    }

    getResourceInfo (resource, isClientShare) {
        if (resource.type === "intercomRecorder") {return strings.RecordingByAgent;}
        else if (resource.type === "PilotSharescreenClientRecorder") {return strings.RecordingByAgent;}
        else if (resource.type === "screenshotIntercom") {return strings.ScreenshotByAgent;}
        else if (resource.type === "screenshotPilotSharescreenClient") {return strings.ScreenshotByAgent;}
        else if (isClientShare) {return strings.SendedByClient;}

        return strings.SendedByAgent;
    }

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const remoteControlPermission = accessrights && accessrights.orgLimitations.allowRemoteControl && accessrights.hasPermission(25, "allow") > 10;
        const noCallMessage = !this.props.communication?.linkedPortalAgent?.isLinked ? strings.TextIntercomUnpaired
            : !this.props.communication.linkedPortalAgent.lockedByPilot ? strings.TextIntercomNotConnected
                : "Aucun appel en cours";
        const sessionDuration = this.state.currentSession && this.state.currentSession.sessionDuration ? this.state.currentSession.sessionDuration : !this.state.currentSession ? null
            : Math.floor((this.state.currentDate - new Date(this.state.currentSession.CallStartingTime)) / 1000);
        const SignalResources = this.state.currentSession && this.state.currentSession.SharedResources ? JSON.parse(this.state.currentSession.SharedResources) : null;
        const resourceList = !SignalResources || SignalResources.shareResources.Data === "" ? [] : JSON.parse(SignalResources.shareResources.Data);
        const clientResourceList = !SignalResources || SignalResources.clientShareResources.Data === "" ? [] : JSON.parse(SignalResources.clientShareResources.Data);
        const codeRemoteControl = this.state.codePairingRemoteControl.padEnd(5, " ");
        const formatedCodeRemoteControl = this.state.codePairingRemoteControl.replace(/\s/g, "");
        const currentPortalAgent = this.props.communication && this.props.communication.linkedPortalAgent;
        const orgId = this.props.currentuser && this.props.currentuser.currentorganization ? this.props.currentuser.currentorganization.id : null;
        const orgUser = orgId ? this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId) : null;

        return <>
            <Area
                helmet={strings.helmetCallLink}
            >
                {
                    !this.state.currentSession || this.state.currentSession.status === "starting" ? <>
                        <div className="horizontalFlexContainer" style={{ height: "100%" }}>
                            <span style={{ flexGrow: "1" }}/>
                            <div className="verticalFlexContainer" style={{ gap: "40px", width: "auto", alignItems: "center", fontSize: "24px", fontWeight: "700" }}>
                                <span style={{ flexGrow: "1" }}/>
                                {
                                    !this.state.currentSession ?
                                        <>
                                            <div style={{ position: "relative" }}>
                                                <IconComponent nameIcon="logo" dimensions={60}/>
                                            </div>
                                            <span>{noCallMessage}</span>
                                            <ButtonSKA
                                                isDisabled={currentPortalAgent === null || currentPortalAgent?.isLinked === false || currentPortalAgent?.modeSleep === 2 || this.props.communication?.callSession }
                                                type="primary"
                                                nameIcon="infinity"
                                                text={strings.SwitchToContinuousMode}
                                                onClick={() => {
                                                    this.setState({
                                                        portalClientSelectionDialog: true,
                                                        portalClientSelectionList: null
                                                    });
                                                    this.props.GetAvailableClientsList((data) => {
                                                        this.setState({ portalClientSelectionList: data });
                                                    });
                                                }}
                                            />
                                        </> : null
                                }
                                {
                                    this.state.currentSession && this.state.currentSession.status === "starting" ?
                                        <span>Vous pouvez accepter l'appel de {this.state.currentSession.PortalClientName} sur votre intercom.</span> : null
                                }
                                <span style={{ flexGrow: "1" }}/>
                            </div>
                            <span style={{ flexGrow: "1" }}/>
                        </div>
                    </> : null
                }
                {
                    this.state.currentSession && (this.state.currentSession.status === "running"
                        || this.state.currentSession.status === "pause"
                        || this.state.currentSession.status === "sleep") ? <>
                            <div style={{ flexDirection: "column", width: "100%", display: "flex", alignItems: "center", gap: "40px", height: "100%" }}>
                                <ActivityIsland
                                    icon={
                                        <Status statusId={!this.props.communication.callSession ? null :
                                            this.props.communication.callSession.status === "starting" ? 50 :
                                                this.props.communication.callSession.status === "pause" ? 30 :
                                                    this.props.communication.callSession.status === "sleep" ? 70 :
                                                        60}/>
                                    }
                                    compartments={[
                                        <span><b>{strings.Zone + " "}</b>{this.state.currentSession.PortalClientZone}</span>,
                                        <span><b>{strings.client + " "}</b>{this.state.currentSession.PortalClientName}</span>,
                                        <span style={{ color: this.state.currentSession.isCallClose ? "var(--grey-light)" : null }}><b>{strings.duree + " "}</b>{(Math.floor(sessionDuration / 60).toString() + ":" + (sessionDuration - Math.floor(sessionDuration / 60) * 60).toString().padStart(2, "0"))}</span>,
                                        this.state.srcSharescreenClient && !this.state.currentSession.isCallClose ?
                                            <span><ButtonSkaRound
                                                type="primary"
                                                onClick={() => {this.setState({ isDisplaySharescreenClient: !this.state.isDisplaySharescreenClient });}}
                                                nameIcon="cast"
                                            /></span>
                                            :
                                            null

                                    ]}
                                />
                                <div style={{ display: "flex", flexDirection: "row", gap: "20px", width: "100%", maxWidth: "1360px", justifyContent: "center", maxHeight: "100%" }}>
                                    <div style={{ display: "flex", height: "fit-content", alignItems: "center", flexDirection: "column", width: "220px", gap: "20px" }}>
                                        <div style={{ display: "flex", height: "fit-content", flexDirection: "column", width: "200px", padding: "10px", gap: "10px", borderRadius: "6px", backgroundColor: "var(--primary-dark)" }}>
                                            {
                                                this.getPanels().map((panel, index) => {
                                                    const selected = this.state.selectedPanelId === panel.id;
                                                    const color = selected ? "var(--primary-base)" : "white";
                                                    const bgcolor = selected ? "white" : "transparent";
                                                    const disabled = panel.id !== "cr" && this.state.currentSession.isCallClose;
                                                    return <div key={index}
                                                        style={{
                                                            width: "calc(100% - 20px)", padding: "10px", display: "flex", flexDirection: "row", gap: "10px",
                                                            cursor: disabled ? "auto" : "pointer", opacity: disabled ? 0.5 : 1,
                                                            backgroundColor: bgcolor, borderRadius: "4px", alignItems: "center"
                                                        }}
                                                        onClick={() => {
                                                            if (!disabled && !selected) {
                                                                this.setState({ selectedPanelId: panel.id });
                                                                panel.onSelect();
                                                            }
                                                        }}>
                                                        <IconComponent dimensions="24" nameIcon={panel.icon} color={selected ? "primary-base" : "white"}/>
                                                        <span style={{ color: color, fontSize: "14px", fontWeight: 600 }}>{panel.title}</span>
                                                        <span style={{ display: "flex", flexGrow: 1 }}/>
                                                        { panel.id === "shared" && (SignalResources && SignalResources.screenAgent.isEnabled.toString() === "true" || resourceList && resourceList.length > 0) ?
                                                            <div style={{ display: "flex", width: "10px", height: "10px", borderRadius: "5px", backgroundColor: "var(--green-base)" }} /> : null
                                                        }
                                                        {
                                                            panel.id === "attachments" && this.state.totalAttachments > 0 ?
                                                                <BadgeAlert value={this.state.totalAttachments} color={"red-base"} />
                                                                :
                                                                null
                                                        }
                                                    </div>;
                                                })
                                            }
                                        </div>
                                        {
                                            this.state.currentSession.isCallClose ? <ButtonSKA
                                                type={"red"}
                                                nameIcon={"handStop"}
                                                text={strings.PermanentlyEndTheCall}
                                                onClick={() => {
                                                    const categ = this.state.selectedCallCategorie;
                                                    if (!categ) {
                                                        this.props.OpenDialog({
                                                            title: strings.MissingInformations,
                                                            boldText: strings.RequiredAction,
                                                            description: strings.textMissingInformations,
                                                            hideClose: true,
                                                            primaryLabel: strings.gotIt,
                                                            clickOutsideToClose: true
                                                        });
                                                        return;
                                                    }
                                                    this.onCloseCurrentSession(() => {});
                                                }}
                                            /> : null
                                        }
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", flexDirection: "column", width: "440px", padding: "0px", gap: "20px", borderRadius: "6px" }}>
                                        {
                                            this.state.selectedPanelId === "cr" ? <>
                                                <CallLinkCard titleElement={{ title: strings.CR }}>
                                                    <span style={{ color: "var(--primary-base)", marginBottom: "10px", fontSize: "14px", fontWeight: "700" }}>{strings.CallCategories}</span>
                                                    <Inputs
                                                        field={
                                                            {
                                                                type: "selectElement",
                                                                preventEmpty: true,
                                                                placeholder: strings.DefineCateg,
                                                                elementsList: { results: this.state.currentSession && this.state.currentSession.Categories && this.state.currentSession.Categories.length > 0 ? this.state.currentSession.Categories :
                                                                    this.state.currentSession && this.state.currentSession.webCallGuid && this.props.monitoring.secondaryFreeCallLinks && this.props.monitoring.secondaryFreeCallLinks.results ?
                                                                        this.props.monitoring.secondaryFreeCallLinks.results.find(fc => fc.guid === this.state.currentSession.webCallGuid).categories : []
                                                                },
                                                                selectedElementId: this.state.selectedCallCategorie ? this.state.selectedCallCategorie.id : null,
                                                                onSelectElement: (element) => {
                                                                    this.onSelectCategory(element);
                                                                }
                                                            }
                                                        }
                                                    />
                                                    <span style={{ display: "flex", height: "20px" }}/>
                                                    <span style={{ color: "var(--primary-base)", marginBottom: "10px", fontSize: "14px", fontWeight: "700" }}>{strings.Notes}</span>
                                                    <TextArea
                                                        placeholder={strings.DescriptionNotes}
                                                        value={this.state.callnotes}
                                                        height="120px"
                                                        onChange={(e) => this.setState({ callnotes: e.target.value })}
                                                    />
                                                </CallLinkCard>
                                            </> : null
                                        }
                                        {
                                            this.state.selectedPanelId === "attachments" ? <>
                                                {
                                                    this.state.totalAttachments === 0 ?
                                                        <CallLinkCard titleElement={{ title: "Pièces jointes" }}>
                                                            <p style={{ color: "var(--grey-base)", margin: 0, textAlign: "center" }}>{strings.noAttachment}</p>
                                                        </CallLinkCard>
                                                        :
                                                        <CallLinkCard titleElement={{ title: strings.Attachments }} maxHeight={"830px"}>
                                                            <Inputs
                                                                field={{
                                                                    type: "selectElement",
                                                                    preventEmpty: true,
                                                                    placeholder: strings.allAttachments,
                                                                    elementsList: { results: [
                                                                        { id: "allAttachments", name: strings.allAttachments },
                                                                        { id: "client", name: strings.AttachmentsSendedByClient },
                                                                        { id: "agent", name: strings.AttachmentsSendedByAgent }
                                                                    ] },
                                                                    selectedElementId: this.state.selectedAttachment ? this.state.selectedAttachment.id : null,
                                                                    onSelectElement: (element) => {
                                                                        this.setState({ selectedAttachment: element });
                                                                    }
                                                                }}
                                                            />

                                                            <span style={{ display: "flex", height: "20px" }}/>
                                                            {
                                                                (!this.state.selectedAttachment || this.state.selectedAttachment.id === "allAttachments" || this.state.selectedAttachment.id === "client") && clientResourceList.map((res) => {
                                                                    return <div style={{
                                                                        height: "56px",
                                                                        width: "calc(100% - 40px)",
                                                                        padding: "0 20px",
                                                                        marginBottom: "20px",
                                                                        borderLeft: "4px solid var(--primary-base)",
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        gap: "20px",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center"
                                                                    }}>
                                                                        <div style={{ display: "flex", flexGrow: "1", overflow: "hidden", flexDirection: "column", justifyContent: "flex-start", textAlign: "left" }}>
                                                                            <span style={{ fontWeight: "700" }}>{this.getResourceInfo(res, true)}</span>
                                                                            <span style={{ opacity: 0.5 }}>{res.name}</span>
                                                                        </div>
                                                                        <ButtonSkaRound
                                                                            type="primary"
                                                                            nameIcon="eye"
                                                                            onClick={() => {
                                                                                window.open(res.url, "_blank", "rel=noopener noreferrer");
                                                                            }}
                                                                        />
                                                                    </div>;
                                                                })
                                                            }
                                                            {
                                                                ( !this.state.selectedAttachment || this.state.selectedAttachment.id === "allAttachments" || this.state.selectedAttachment.id === "agent") && resourceList.map((res) => {
                                                                    return <div style={{
                                                                        height: "56px",
                                                                        width: "calc(100% - 40px)",
                                                                        padding: "0 20px",
                                                                        marginBottom: "20px",
                                                                        borderLeft: "4px solid var(--primary-base)",
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        gap: "20px",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center"
                                                                    }}>
                                                                        <div style={{ display: "flex", flexGrow: "1", overflow: "hidden", flexDirection: "column", justifyContent: "flex-start", textAlign: "left" }}>
                                                                            <span style={{ fontWeight: "700" }}>{this.getResourceInfo(res, false)}</span>
                                                                            <span style={{ opacity: 0.5 }}>{res.name}</span>
                                                                        </div>
                                                                        <ButtonSkaRound
                                                                            type="primary"
                                                                            nameIcon="eye"
                                                                            onClick={() => {
                                                                                window.open(res.url, "_blank", "rel=noopener noreferrer");
                                                                            }}
                                                                        />
                                                                    </div>;
                                                                })
                                                            }
                                                        </CallLinkCard>
                                                }
                                            </> : null
                                        }
                                        {
                                            this.state.selectedPanelId === "shared" ? <>
                                                <CallLinkCard
                                                    titleElement={{ title: strings.Sharescreen }}
                                                    childElements={[
                                                        {
                                                            title: strings.MyComputerScreen,
                                                            checked: SignalResources && SignalResources.screenAgent.isEnabled.toString() === "true",
                                                            onChange: () => {
                                                                const newvalue = SignalResources.screenAgent.isEnabled.toString() === "true" ? false : true;
                                                                this.onChangeResource("mainTools", "shareScreen", newvalue);
                                                                this.onChangeResource("screenAgent", "isEnabled", newvalue);
                                                            }
                                                        }
                                                    ]}
                                                />
                                                <CallLinkCard
                                                    titleElement={{
                                                        title: strings.SendingContent
                                                    }}
                                                    maxHeight={"650px"}
                                                    childElements={[
                                                        ... resourceList ? resourceList
                                                            .filter(item => item.type !== "screenshotIntercom" && item.type !== "intercomRecorder")
                                                            .slice(0, 3) // Max 3 éléments
                                                            .map((res, index) => {
                                                                return {
                                                                    title: res.name,
                                                                    titleIcon: res.type === "weburl" ? "url" : "file",
                                                                    actionIcon: "trash",
                                                                    actionType: "secondary",
                                                                    onAction: () => {
                                                                        const data = JSON.parse(SignalResources.shareResources.Data);
                                                                        data.splice(index, 1);
                                                                        this.onChangeResource("mainTools", "shareResources", true);
                                                                        this.onChangeResource("shareResources", "Data", JSON.stringify(data));
                                                                    }
                                                                };
                                                            }) : []
                                                        ,
                                                        // Display add card only if elements filtered < 3
                                                        ...resourceList && resourceList.filter(item =>
                                                            item.type !== "screenshotIntercom" && item.type !== "intercomRecorder"
                                                        ).length < 3
                                                            ? [{
                                                                title: "",
                                                                actionIcon: "add",
                                                                actionType: "primary",
                                                                onAction: () => {
                                                                    this.setState({
                                                                        shareResourceListSelected: null,
                                                                        tempResource: { name: "", url: "", type: "weburl" }
                                                                    });
                                                                }
                                                            }]
                                                            : []

                                                    ]}
                                                />
                                            </> : null
                                        }
                                        {
                                            this.state.selectedPanelId === "control" ? <>
                                                <CallLinkCard titleElement={{ title: strings.Control }}>
                                                    <span style={{ marginBottom: "20px", fontSize: "14px", fontWeight: "700" }}>{strings.controltitle}</span>
                                                    <span style={{ marginBottom: "20px", fontSize: "14px", fontWeight: "400" }}>{strings.control1}</span>
                                                    <span style={{ marginBottom: "20px", fontSize: "14px", fontWeight: "400" }}>{strings.control2}</span>
                                                    <span style={{ fontSize: "14px", fontWeight: "400" }}>{strings.control3}</span>
                                                </CallLinkCard>
                                            </> : null
                                        }
                                        {
                                            this.state.selectedPanelId === "payment" ? <>
                                                <CallLinkCard
                                                    flexGrow={1}
                                                    disabled={this.state.currentSession.isCallClose}
                                                    titleElement={{
                                                        title: strings.Payment,
                                                        checked: SignalResources && SignalResources.mainTools.payment.toString() === "true",
                                                        onChange: () => {
                                                            this.closePaymentToggle();
                                                        }
                                                    }}
                                                >
                                                    {
                                                        SignalResources && SignalResources.mainTools.payment ? <>
                                                            {
                                                                this.state.isSendRequestForConsent ?
                                                                    <div className="callLinkSmallCardsContainer" style={{ padding: "20px", gap: "20px", flexGrow: "1" }}>
                                                                        {
                                                                            this.state.isSendRequestForConsent ?
                                                                                <div className="card-consent">
                                                                                    <p className="title-consent">{strings.ConsentRequestSent}</p>
                                                                                    <p className="date-consent">{this.state.formatedDateRequestConsent}</p>
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                        {
                                                                            this.state.consent.isAccepted ?
                                                                                <div className="card-consent-accepted">
                                                                                    <p className="title-consent-accepted">{strings.ConsentGranted}</p>
                                                                                    <p className="date-consent">{this.state.formatedResponseForConsent}</p>
                                                                                    <p className="text-consent">{strings.DescriptionConsentGranted}</p>
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                        {
                                                                            this.state.isDisplayRefusedConsent ?
                                                                                <div className="card-consent-refused">
                                                                                    <p className="title-consent-refused">{strings.ConsentRefused}</p>
                                                                                    <p className="date-consent">{this.state.formatedResponseForConsent}</p>
                                                                                    <p className="text-consent">{strings.DescriptionConsentRefused}</p>
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div className="callLinkSmallCardsContainer" style={{ padding: "20px", gap: "20px", flexGrow: "1" }}></div>
                                                            }
                                                            <div className="box-send-payment">
                                                                <ButtonSKA
                                                                    isDisabled={this.state.currentSession.isCallClose
                                                               || this.state.isSendRequestForConsent && !this.state.isDisplayRefusedConsent
                                                               || !SignalResources || SignalResources.mainTools.payment.toString() === "false"
                                                                    }
                                                                    type="primary-icon"
                                                                    onClick={() => this.handleClickSendConsentCreditCard()}
                                                                    nameIcon="chevronRight"
                                                                    text={strings.AskingForConsent}
                                                                />
                                                            </div>
                                                        </> : null
                                                    }
                                                </CallLinkCard>
                                            </> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </> : null
                }
            </Area>
            <Modal open={this.state.portalClientSelectionDialog}
                onClose={() => {this.setState({ portalClientSelectionDialog: null });}}
                validationTitle={strings.Start}
                onValidate={() => {
                    if (currentPortalAgent && !this.props.communication.callSession) {
                        const id = this.state.selectedPortalClientId;
                        if (id) {
                            this.props.communication.webRTConnection.invoke("StartContinuousStreamCall", id.toString()).then(() => {
                                console.log("==>StartContinuousStreamCall", id);
                            });
                            this.props.history.push("/callLink");
                        }
                        this.setState({ portalClientSelectionDialog: null });
                    }
                    else {
                        this.setState({ portalClientSelectionDialog: null });
                    }
                }}
                title={strings.SwitchToContinuousMode}
                icon={"infinity"}
            >
                <span className="TextContent16" style={{ color: "var(--grey-base)" }}>
                    {strings.ChoosingTheCapsuleToTarget + " :"}
                </span>
                {
                    this.state.portalClientSelectionList ?
                        <Inputs
                            noLabel={true}
                            field={{
                                openTop: false,
                                adjustHeight: true,
                                type: "selectElement",
                                elementsList: { results: this.state.portalClientSelectionList
                                    .filter(el => el?.StatusId?.toString() === "40")
                                    .map(el => ({ id: el.Id, name: el.Name })) },
                                selectedElementId: this.state.selectedPortalClientId,
                                onSelectElement: (el) => {
                                    if (!el) {this.setState({ selectedPortalClientId: null });}
                                    else {this.setState({ selectedPortalClientId: el.id });}
                                }
                            }}
                        /> : <Loader dimensions="40px" color={"var(--primary-base)"} />
                }
            </Modal>
            <Modal open={this.state.tempResource !== null}
                onClose={() => this.setState({ tempResource: null })}
                disableValidate={
                    this.state.loadingFile || !this.state.tempResource || !this.state.tempResource.url || this.state.tempResource.url === ""
                }
                onValidate={ () => {
                    const data = !SignalResources || SignalResources.shareResources.Data === "" ? [] : JSON.parse(SignalResources.shareResources.Data);
                    data.push(this.state.tempResource);
                    this.onChangeResource("shareResources", "Data", JSON.stringify(data));
                    this.setState({ tempResource: null });
                }}
                title={strings.sendContent}
                icon={"qrcode"}
                validationTitle = {this.state.loadingFile ? strings.Loading : strings.Send}
            >
                {this.state.tempResource ? <AppBar
                    onSelectSlide={(slide) => {
                        this.setState({
                            shareResourceListSelected: slide.title === strings.Resource,
                            selectResourceDialog: slide.title === strings.Resource ? true : null,
                            isOnPC: slide.title === strings.FromMyComputer
                        });
                    }}
                    slides={[
                        {
                            title: strings.webLink,
                            content: <div style={{ padding: "0px 20px", display: "flex", gap: "20px", width: "calc(100% - 40px)", flexDirection: "column" }}>
                                <Inputs field={{
                                    type: "textfield",
                                    title: strings.titleDescription,
                                    width: "40px",
                                    value: this.state.tempResource.name,
                                    onChange: (e) => {
                                        const tempEdit = this.state.tempResource;
                                        tempEdit.name = e.target.value;
                                        tempEdit.type = "weburl";
                                        this.setState({
                                            tempResource: tempEdit
                                        });
                                    } }
                                }/>
                                <Inputs field={{
                                    type: "prefixedTextfield",
                                    title: strings.feedUrl,
                                    width: "40px",
                                    prefix: "https://",
                                    value: this.state.tempResource.url,
                                    onChange: (e) => {
                                        const tempEdit = this.state.tempResource;
                                        tempEdit.url = e.target.value;
                                        tempEdit.type = "weburl";
                                        this.setState({
                                            tempResource: tempEdit
                                        });
                                    }
                                }}/>
                                <Toggle
                                    type="check"
                                    disabled={!this.state.tempResource || this.state.tempResource.checked || !this.state.tempResource.url || this.state.tempResource.url === "" || !this.state.tempResource.name || this.state.tempResource.name === "" }
                                    name={strings.addURLToResource}
                                    checked={this.state.tempResource && this.state.tempResource.checked}
                                    onClick={() => {
                                        const obj = {
                                            id: 0,
                                            name: this.state.tempResource.name,
                                            contentTypeId: 10,
                                            contentGroupId: null,
                                            timestamp: null,
                                            data: JSON.stringify({ weburl: this.state.tempResource.url })
                                        };
                                        const formData = new FormData();
                                        formData.append("contentObjAsString", JSON.stringify(obj));
                                        this.props.CreateContent(
                                            formData,
                                            (updatedContentTimestamp) => {
                                                toast.success(strings.successfullSave);
                                                this.setState({
                                                    tempResource: { ...tempResource, checked: true }
                                                });
                                            },
                                            () => {}
                                        );
                                    }}
                                />
                            </div>
                        },
                        {
                            title: strings.FromMyComputer,
                            content: <div style={{ padding: "0px 20px", display: "flex", gap: "20px", width: "calc(100% - 40px)", flexDirection: "column" }}>
                                <Inputs field={{
                                    type: "textfield",
                                    title: strings.titleDescription,
                                    width: "40px",
                                    value: this.state.tempResource.name,
                                    disabled: true,
                                    onChange: (e) => { } }
                                }/>
                                <Inputs field={{
                                    type: "importfile",
                                    title: strings.File,
                                    width: "40px",
                                    value: this.state.tempResource.name,
                                    thumbnail: this.state.tempResource.url ? this.state.tempResource.url : "none",
                                    access: "all",
                                    onAddFiles: (files) => {
                                        this.addDocumentToTempResource(files);
                                    }
                                }}/>
                            </div>
                        },
                        {
                            title: strings.Resource,
                            content: <div style={{ padding: "0px 20px", display: "flex", gap: "20px", width: "calc(100% - 40px)", flexDirection: "column" }}>
                                <Inputs field={{
                                    type: "textfield",
                                    title: strings.titleDescription,
                                    width: "40px",
                                    value: this.state.tempResource.name,
                                    disabled: true,
                                    onChange: (e) => { } }
                                }/>
                                <Inputs field={{
                                    type: "importfile",
                                    title: strings.File,
                                    width: "40px",
                                    value: this.state.tempResource.name,
                                    thumbnail: this.state.tempResource.type && this.state.tempResource.type === "doc" && this.state.tempResource.url ? this.state.tempResource.url : "none",
                                    onOpenModal: () => {
                                        this.setState({ selectResourceDialog: true });
                                    }
                                }}/>
                            </div>
                        }
                    ]}/> : null}
            </Modal>
            <SelectResourceDialog open={this.state.selectResourceDialog !== null}
                icon="qrcode"
                title={strings.selectContent}
                onClose={() => this.setState({ selectResourceDialog: null })}
                onSelect={ (element) => {
                    const eldata = JSON.parse(element.data);
                    const tempResource = {};
                    tempResource.type = element.contentTypeId !== 10 ? "doc" : "weburl";
                    tempResource.name = element.name;
                    tempResource.url = element.contentTypeId !== 10 ? eldata.Uri : eldata.weburl;
                    this.setState({
                        tempResource: tempResource,
                        selectResourceDialog: null
                    });
                }}/>
            <Modal
                open={this.state.srcSharescreenClient && this.state.isDisplaySharescreenClient}
                onClose={() => this.captureScreenshot()}
                title={`${strings.ClientSharescreen} ${SignalResources && SignalResources.clientCall.nameUser ? ": " + SignalResources.clientCall.nameUser : ""}`}
                icon={"cast"}
                widthModalPaper={"calc(100% - 80px)"}
                heightHorizontalFlexContainer="100%"
                heightModalBody="100%"
                style={{ width: "100%", height: "100%", border: this.state.isRemoteControlStarted ? "5px solid var(--red-base)" : null }}
                fields={[
                    {
                        type: "custom",
                        heightHorizontalFlexContainer: "100%",
                        child: <div style={{ height: "100%", width: "100%", position: "relative" }}>
                            <canvas className="canvas-recorder-display" ref={this.canvasRecorderSharescreenRef} style={{ display: "none" }} width={1280} height={720} />
                            <video
                                style={{ objectFit: "cover", maxHeight: "100%", width: "100%", cursor: this.state.isRemoteControlStarted ? "none" : "default" }}
                                className="sharescreen-call-app"
                                id='remoteScreenClient'
                                muted
                                autoPlay
                                playsInline
                                onMouseDown={this.state.isRemoteControlStarted ? (e) => this.handleMouseDown(e) : null}
                                onMouseMove={this.state.isRemoteControlStarted ? (e) => this.handleMouseMove(e) : null}
                                onMouseUp={this.state.isRemoteControlStarted ? (e) => this.handleMouseUp(e) : null}
                                onContextMenu={this.state.isRemoteControlStarted ? (e) => this.handleMouseRightClick(e) : null}
                                onFocus={() => this.setState({ isFocusSharescreen: true })}
                                tabIndex={0}
                                onBlur={() => this.setState({ isFocusSharescreen: false })}
                                ref={this.videoSharescreenRef}
                            >
                            </video>
                            {
                                this.state.showPairingCodeDialog ?
                                    <div className="modal-pairing-code">
                                        <div>
                                            <p className="text-modal-pairing-code"><span style={{ fontWeight: 700, color: this.state.showErrorMessagePairingCode || this.state.showErrorMessagePairingCodeAlreadyUsed ? "var(--red-base)" : "var(--carbone)" }}>{this.state.showErrorMessagePairingCode ? strings.ErrorTextParingCodeLine1 : this.state.showErrorMessagePairingCodeAlreadyUsed ? strings.ErrorTextParingCodeAlreadyUsedLine1 : strings.TextParingCodeLine1}</span></p>
                                            <p className="text-modal-pairing-code">{this.state.showErrorMessagePairingCode || this.state.showErrorMessagePairingCodeAlreadyUsed ? null : strings.TextParingCodeLine2}</p>
                                        </div>
                                        <div className="container-code-input">
                                            {[...Array(5)].map((_, index) =>
                                                <input
                                                    key={index}
                                                    type="text"
                                                    maxLength={1}
                                                    className="code-digit"
                                                    style={{
                                                        borderBottom: this.state.showErrorMessagePairingCode || this.state.showErrorMessagePairingCodeAlreadyUsed ? "1px solid var(--red-base)" : "1px solid var(--grey-base)",
                                                        color: this.state.showErrorMessagePairingCode || this.state.showErrorMessagePairingCodeAlreadyUsed ? "var(--red-base)" : "var(--carbone)"
                                                    }}
                                                    value={codeRemoteControl.charAt(index).trim()}
                                                    onChange={(e) => {
                                                        if (!this.state.showErrorMessagePairingCode || !this.state.showErrorMessagePairingCodeAlreadyUsed) {
                                                            this.handleChangeInputCodeRemoteControl(e.target.value, index);
                                                        }
                                                    }}
                                                    onFocus={() => {
                                                        if (this.state.showErrorMessagePairingCode || this.state.showErrorMessagePairingCodeAlreadyUsed) {
                                                            this.setState({
                                                                codePairingRemoteControl: "",
                                                                showErrorMessagePairingCode: false,
                                                                showErrorMessagePairingCodeAlreadyUsed: false
                                                            });
                                                            this.inputsPairingRemoteControlRef.forEach((ref) => {
                                                                if (ref && ref.current) {
                                                                    ref.current.value = "";
                                                                }
                                                            });
                                                        }
                                                    }}
                                                    onKeyDown={(e) => this.handleKeyDownInputCodeRemoteControl(e, index)}
                                                    ref={this.inputsPairingRemoteControlRef[index]}
                                                />
                                            )}
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <ButtonSKA
                                                type={"primary-icon"}
                                                isDisabled={this.state.showErrorMessagePairingCode || this.state.showErrorMessagePairingCodeAlreadyUsed || formatedCodeRemoteControl.length !== 5}
                                                onClick={() => this.startingRemoteControl()}
                                                nameIcon={"check"}
                                                text={strings.StartRemoteControl}
                                            />
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            <Modal
                                open={this.state.showMessageRemoteControlCrashed}
                                onClose={() => this.setState({ showMessageRemoteControlCrashed: false })}
                                title={"Contrôle à distance interrompu"}
                                icon={"alertTriangle"}
                                style={{ width: "100%", height: "100%" }}
                                heightModalBody={"auto"}
                                fields={[
                                    {
                                        type: "custom",
                                        child: <div style={{ fontSize: "14px", fontWeight: 400, color: "var(--carbone)" }}>
                                            La session de contrôle à distance a été interrompue en raison d'un problème inopiné.
                                        </div>
                                    }
                                ]}
                                textSecondaryButton={"OK"}
                                iconSecondaryButton={"check"}
                            />
                        </div>
                    }
                ]}
                headerButton={[
                    {
                        type: "primary",
                        onClick: () => this.setState({ isDisplaySharescreenClient: false }),
                        nameIcon: "cancel"
                    }
                ]}
                isButtonGroup={!remoteControlPermission ? false : this.state.showPairingCodeDialog ? false : true}
                textInfoButtonGroup={strings.ControlClientComputer}
                typeFirstButtonGroup={this.state.displayButtonStopRemoteControl ? "red" : "primary-icon"}
                onClickFirstButtonGroup={() => this.state.displayButtonStopRemoteControl ? this.stopRemoteControl() : this.sendRemoteControlRequest(false)}
                iconFirstButtonGroup={this.state.displayButtonStopRemoteControl ? "handStop" : "apple"}
                fillIconFirstButtonGroup={this.state.displayButtonStopRemoteControl ? false : true}
                reverseIconFirstButtonGroup={this.state.displayButtonStopRemoteControl ? false : true}
                textFirstButtonGroup={this.state.displayButtonStopRemoteControl ? strings.ToEnd : strings.Mac}
                typeSecondButtonGroup={"primary-icon"}
                onClickSecondButtonGroup={this.state.displayButtonStopRemoteControl ? null : () => this.sendRemoteControlRequest(true)}
                iconSecondButtonGroup="windows"
                fillIconSecondButtonGroup={true}
                reverseIconSecondButtonGroup={true}
                textSecondButtonGroup={strings.Windows}
                onValidate={() => this.setState({ isRecording: !this.state.isRecording })}
                isValidationRecording= {this.state.isRecording ? true : false}
                validationTitle={this.state.counterRecorder > 0 ? <>{strings.register} <BadgeAlert value={this.state.counterRecorder} color={"red-base"} /></> : strings.register}
                validationIcon="record"
                isSecondaryButtonToPrimary={true}
                textSecondaryButton={this.state.counterScreenshot > 0 ? <>{strings.Capture} <BadgeAlert value={this.state.counterScreenshot} color={"red-base"} /></> : strings.Capture}
                iconSecondaryButton="screenshot"
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(CallPanel);
